export const stripeStatuses = [
    "active",
    "trialing",
    "past_due",
    "canceled",
    "empty",
    "incomplete",
    "incomplete_expired",
    "unpaid",
] as const;
